import fetch from '@/api/fetch'

/** 获取角色列表 */
export const getList = data => fetch.post('/sys/role/getList', data);

/** 添加 */
export const save = data => fetch.post('/sys/role/save', data);

/** 删除 */
export const del = data => fetch.post('/sys/role/del', data);

/** 启用禁用 */
export const isEffective = data => fetch.post('/sys/role/isEffective', data);

/** 所有企业/平台权限分组. */
export const powerAllGroup = data => fetch.post('/sys/role/powerAllGroup', data);

/** 获取角色拥有的权限id列表 */
export const getPowerIdsByRoleId = roleId => fetch.get(`/sys/role/power/ids/${roleId}`);


/** 所有企业/平台权限分组. */
export const saveRolePower = data => fetch.post('/sys/role/saveRolePower', data);

/** 获取角色人员列表 */
export const getRoleUserList = data => fetch.post('/sys/role/getRoleUserList', data);

/** 获取平台人员列表 */
export const getAllUserList = data => fetch.post('/sys/role/getAllUserList', data);

/** 保存人员角色信息 */
export const saveRoleUser = data => fetch.post('/sys/role/saveRoleUser', data);

/** 保存人员角色信息 */
export const delRoleUser = data => fetch.post('/sys/role/delRoleUser', data);